/**Dependencies */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getDestinations } from "../services/searchService";
import Swal from "sweetalert2";

/**Components */
import { Form, Button, Row, Col, Card } from "react-bootstrap";
import { RoomsSelector } from "./RoomsSelector";
import { DestinationsList } from "./DestinationsList";
import { setLabelPax } from "../helpers";
import Flatpickr from "react-flatpickr";

import { FaRegCalendarAlt } from "react-icons/fa";

/**Styles */
import "../styles/index.scss";
import { FaMapLocation } from "react-icons/fa6";
import { MdFamilyRestroom } from "react-icons/md";

export const SearchEngine = ({
  isModify,
  modifyHotel,
  hotelId,
  hideDestinations,
  totalRooms,
  destination,
  idLocation,
  arrayRooms,
  selectedDates,
}) => {
  const navigate = useNavigate();
  const today = new Date();

  const [dates, setDates] = useState([
    new Date(today.getFullYear(), today.getMonth(), today.getDate() + 5)
      .toISOString()
      .split("T")[0],
    new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7)
      .toISOString()
      .split("T")[0],
  ]);
  const [nameDestination, setNameDestination] = useState(destination || "");
  const [isSelecting, setIsSelecting] = useState(false);
  const [idDestination, setIdDestination] = useState(idLocation);
  const [typeSearch, setTypeSearch] = useState(
    modifyHotel === "hotel" ? "hotel" : "destino"
  );
  const [showDestinationList, setShowDestinationList] = useState(false);
  const [rooms, setRooms] = useState([
    { room: 1, adults: 2, minors: 0, ages: [] },
  ]);
  const [hidePaxSelection, setHidePaxSelection] = useState("none");
  const [labelRooms, setLabelRooms] = useState("");
  const [filteredDestinations, setFilteredDestinations] = useState([]);
  const [filteredHotels, setFilteredHotels] = useState([]);

  /**Función para setear el label con el número de pax.*/
  useEffect(() => {
    setLabelRooms(setLabelPax(totalRooms.length > 0 ? totalRooms : rooms));
  }, [rooms, totalRooms]);

  /**Función para verificar si existe informacion de busqueda en el session storage.*/
  useEffect(() => {
    if (totalRooms.length > 0) {
      setNameDestination(destination);
      setRooms(arrayRooms);
      setIsSelecting(true);
      setDates(selectedDates);
    }
  }, [destination]);

  useEffect(() => {
    isModify && setDates(selectedDates);
  }, [selectedDates]);

  useEffect(() => {
    // Verificar que el input tenga al menos 4 caracteres
    if (nameDestination.length >= 3 && !isSelecting) {
      const fetchData = async () => {
        try {
          const result = await getDestinations(nameDestination);
          setShowDestinationList(true);
          filterHotels(result);
        } catch (error) {
          console.error("Error en la llamada a la API:", error);
        } /* finally {
          setIsFetching(false); // Indicar que la llamada terminó
        } */
      };

      const delayDebounceFn = setTimeout(() => {
        fetchData();
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    }
  }, [nameDestination]);

  /**
   * Filtra los destinos y hoteles obtenidos de la API y los limita a 10
   * para mostrarlos en la lista desplegable.
   * @param {Object} hotels - Un objeto con una propiedad "destinos" y otra "hoteles"
   *                           que contienen listas de destinos y hoteles.
   */
  const filterHotels = (hotels) => {
    const destinosFiltrados = hotels.destinos.slice(0, 10);
    const hotelesFiltrados = hotels.hoteles.slice(0, 10);

    setFilteredDestinations(destinosFiltrados);
    setFilteredHotels(hotelesFiltrados);
  };

  /**
   * Construye una URL con parámetros de búsqueda de alojamiento y navega hasta ella.
   * La URL incluye destino, fechas de entrada y salida, número de habitaciones,
   * y detalles de las habitaciones incluyendo adultos, menores y sus edades.
   * Utiliza `navigate` de React Router para redirigir a la URL generada.
   */
  const redirectResults = () => {
    if (!nameDestination.trim()) {
      Swal.fire({
        icon: "error",
        title: "El campo de destino no puede estar vacio.",
        text: "Por favor intentelo de nuevo.",
      });
    } else {
      const destino = modifyHotel === "hotel" ? hotelId : idDestination;
      const checkIn = dates[0];
      const checkOut = dates[1];

      // Crear los parámetros de habitaciones (pax)
      const paxParams = rooms
        .map((hab, index) => {
          const adultos = hab.adults;
          const menores = hab.minors;
          const edades = hab.ages.length > 0 ? hab.ages.join(",") : "0";
          return `pax${index + 1}=${adultos}|${menores}|${edades}`;
        })
        .join("&"); // Unir todos los parámetros de habitaciones con "&"
      let url = "";
      // Armar la URL completa
      if (typeSearch === "destino") {
        url = `/alojamientos?t=destino&id=${destino}&in=${checkIn}&out=${checkOut}&hab=${rooms.length}&${paxParams}`;
      } else {
        url = `/hotel?idHotel=${destino}&in=${checkIn}&out=${checkOut}&hab=${rooms.length}&${paxParams}`;
      }
      // Usar React Router para redirigir
      navigate(url);
    }
  };

  /**
   * Maneja los cambios en la selección de fecha formateando las fechas seleccionadas
   * en formato 'aaaa-MM-dd' y actualizando el estado con las fechas formateadas.
   * @param {Array} dates: una matriz de objetos Date que representan el rango de fechas seleccionado.
   */
  const handleDateChange = (dates) => {
    if (dates.length === 2) {
      const startDate = dates[0];
      const endDate = dates[1];

      // Calcular la diferencia de días entre las fechas seleccionadas
      const diffTime = Math.abs(endDate - startDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays > 15) {
        alert("Solo puedes seleccionar un máximo de 15 días.");

        // Restablecer al estado inicial definido por el usuario
        const today = new Date();
        setDates([
          new Date(today.getFullYear(), today.getMonth(), today.getDate() + 5)
            .toISOString()
            .split("T")[0],
          new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7)
            .toISOString()
            .split("T")[0],
        ]);
        return;
      }
    }

    // Convertimos las fechas a formato yyyy-MM-dd
    const formatted = dates.map((date) => date.toISOString().split("T")[0]);
    setDates(formatted); // Guardamos las fechas formateadas en el estado
  };

  /**
   * Maneja la selección de un item en la lista desplegable de destinos o hoteles.
   * @param {Object} item - El objeto seleccionado que contiene la información del destino o hotel.
   * @param {string} label - El label del item seleccionado.
   * @param {string} type - El tipo de item seleccionado, puede ser "destino" o "hotel".
   */
  const handleSelect = (item, label, type) => {
    setShowDestinationList(false);
    setIdDestination(item);
    setNameDestination(label);
    setTypeSearch(type);
    setIsSelecting(true);
  };

  return (
    <>
      {isModify ? (
        <div className="modify-search shadow-box">
          <Card>
            <Card.Body>
              <Card.Title className="title-modify">
                Modificar búsqueda
              </Card.Title>
              <Form>
                {!hideDestinations && (
                  <Form.Group
                    className="mt-3 mb-4"
                    controlId="formModifyDestinations"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Busca tu hotel o destino"
                      value={nameDestination}
                      className="banner-principal__inputs-search"
                      onChange={(e) => (
                        setNameDestination(e.target.value),
                        setIsSelecting(false)
                      )}
                      required
                    />
                    <DestinationsList
                      showDestinationList={showDestinationList}
                      query={nameDestination}
                      filteredDestinations={filteredDestinations}
                      filteredHotels={filteredHotels}
                      handleSelectItem={handleSelect}
                    />
                  </Form.Group>
                )}

                <Form.Group className="mt-4 mb-4" controlId="formCalendar">
                  <div>
                    <Flatpickr
                      className="banner-principal__inputs-search__input-calendar"
                      placeholder="Fecha de viaje"
                      options={{
                        minDate: new Date().fp_incr(5),
                        mode: "range",
                        showMonths: 2,
                        dateFormat: "Y-m-d",
                        defaultDate: dates,
                        locale: {
                          firstDayOfWeek: 1,
                          rangeSeparator: " a ",
                          weekdays: {
                            shorthand: [
                              "Do",
                              "Lu",
                              "Ma",
                              "Mi",
                              "Ju",
                              "Vi",
                              "Sa",
                            ],
                            longhand: [
                              "Domingo",
                              "Lunes",
                              "Martes",
                              "Miércoles",
                              "Jueves",
                              "Viernes",
                              "Sábado",
                            ],
                          },
                          months: {
                            shorthand: [
                              "Ene",
                              "Feb",
                              "Mar",
                              "Abr",
                              "May",
                              "Jun",
                              "Jul",
                              "Ago",
                              "Sep",
                              "Оct",
                              "Nov",
                              "Dic",
                            ],
                            longhand: [
                              "Enero",
                              "Febrero",
                              "Мarzo",
                              "Abril",
                              "Mayo",
                              "Junio",
                              "Julio",
                              "Agosto",
                              "Septiembre",
                              "Octubre",
                              "Noviembre",
                              "Diciembre",
                            ],
                          },
                        },
                        onClose: function (selectedDates, dateStr, instance) {
                          handleDateChange(selectedDates);
                        },
                      }}
                      value={dates}
                    />
                  </div>
                </Form.Group>
                <Form.Group className="mt-2 mb-3" controlId="formPaxSelection">
                  <Form.Control
                    type="text"
                    placeholder="¿Quiénes viajan?"
                    defaultValue={labelRooms}
                    className="banner-principal__inputs-search"
                    onClick={() => setHidePaxSelection("block")}
                  />
                  <RoomsSelector
                    showSelector={hidePaxSelection}
                    setShowSelector={setHidePaxSelection}
                    roomsData={rooms}
                    setArrRooms={setRooms}
                  />
                </Form.Group>
              </Form>
              <div style={{ textAlign: "center" }}>
                <Button
                  className="banner-principal__btn-search btn-blue"
                  onClick={redirectResults}
                >
                  Buscar
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      ) : (
        <div className="banner-principal__card-container">
          {/* Badge en la esquina superior izquierda */}
          <div className="banner-principal__badge">Reserva tu hotel</div>
          <Card
            style={{
              backgroundColor: "#023672",
              border: "none",
              padding: "20px",
              borderTopLeftRadius: "0px",
            }}
          >
            <Form>
              <Row className="mb-3">
                <Col lg={4} md={6} className="mt-2">
                  <div className="d-flex align-items-center form-control banner-principal__inputs-search">
                    <FaMapLocation style={{ fontSize: "17px" }} />
                    <Form.Control
                      type="text"
                      placeholder="Busca tu hotel o destino"
                      value={nameDestination}
                      className="banner-principal__inputs-search border-0 shadow-none"
                      style={{
                        backgroundColor: "transparent",
                        background: "transparent",
                      }}
                      onChange={(e) => (
                        setNameDestination(e.target.value),
                        setIsSelecting(false)
                      )}
                      required
                    />
                  </div>
                  <DestinationsList
                    showDestinationList={showDestinationList}
                    query={nameDestination}
                    filteredDestinations={filteredDestinations}
                    filteredHotels={filteredHotels}
                    handleSelectItem={handleSelect}
                  />
                </Col>
                <Col lg={3} md={6} className="mt-2">
                  {/* <Form.Control type="text" placeholder="Fecha de viaje" className='banner-principal__inputs-search' /> */}
                  <div className="d-flex align-items-center form-control banner-principal__inputs-search">
                    <FaRegCalendarAlt style={{ fontSize: "17px" }} />
                    <Flatpickr
                      className="banner-principal__inputs-search__input-calendar shadow-none border-0"
                      placeholder="Fecha de viaje"
                      style={{
                        backgroundColor: "transparent",
                        background: "transparent",
                      }}
                      options={{
                        minDate: new Date().fp_incr(5),
                        mode: "range",
                        dateFormat: "Y-m-d",
                        defaultDate: dates,
                        showMonths: 2,
                        locale: {
                          rangeSeparator: " a ",
                          firstDayOfWeek: 1,
                          weekdays: {
                            shorthand: [
                              "Do",
                              "Lu",
                              "Ma",
                              "Mi",
                              "Ju",
                              "Vi",
                              "Sa",
                            ],
                            longhand: [
                              "Domingo",
                              "Lunes",
                              "Martes",
                              "Miércoles",
                              "Jueves",
                              "Viernes",
                              "Sábado",
                            ],
                          },
                          months: {
                            shorthand: [
                              "Ene",
                              "Feb",
                              "Mar",
                              "Abr",
                              "May",
                              "Jun",
                              "Jul",
                              "Ago",
                              "Sep",
                              "Оct",
                              "Nov",
                              "Dic",
                            ],
                            longhand: [
                              "Enero",
                              "Febrero",
                              "Мarzo",
                              "Abril",
                              "Mayo",
                              "Junio",
                              "Julio",
                              "Agosto",
                              "Septiembre",
                              "Octubre",
                              "Noviembre",
                              "Diciembre",
                            ],
                          },
                        },
                        onClose: function (selectedDates, dateStr, instance) {
                          // Asegura que Flatpickr no avance automáticamente
                          handleDateChange(selectedDates);
                        },
                      }}
                      value={dates}
                    />
                  </div>
                </Col>
                <Col lg={3} md={6} className="mt-2">
                  <div className="d-flex align-items-center form-control banner-principal__inputs-search">
                    <MdFamilyRestroom style={{ fontSize: "17px" }} />
                    <Form.Control
                      type="text"
                      placeholder="¿Quiénes viajan?"
                      defaultValue={labelRooms}
                      style={{
                        backgroundColor: "transparent",
                        background: "transparent",
                      }}
                      className="banner-principal__inputs-search border-0 shadow-none"
                      onClick={() => setHidePaxSelection("block")}
                      readOnly
                    />
                  </div>
                  <RoomsSelector
                    showSelector={hidePaxSelection}
                    setShowSelector={setHidePaxSelection}
                    roomsData={rooms}
                    setArrRooms={setRooms}
                  />
                </Col>

                <Col lg={2} md={6} className="mt-3">
                  <div style={{ textAlign: "center" }}>
                    <Button
                      className="banner-principal__btn-search btn-red"
                      onClick={redirectResults}
                    >
                      Buscar
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </Card>
        </div>
      )}
    </>
  );
};
